"use client";

import React from "react";
import Image from "next/image";

export default function Terms({ common_page_list }) {
  if (!common_page_list?.page_name) return null;

  return (
    <div
      className="reecosys-main-wrapper"
      id="reecosys-main-wrapper"
      //   onClick={() => {
      // This replaces ng-click="country_code_click_false()"
      // if (typeof window !== "undefined") {
      //   const event = new CustomEvent("country_code_click_false");
      //   window.dispatchEvent(event);
      // }
      //   }}
    >
      <div
        id="reecosys-aboutus-wrapper"
        className="relative inner-flex inner-flex-big"
      >
        <section
          className="reecosys-section relative wow fadeIn"
          data-wow-delay="0.6s"
          data-wow-duration="0.4s"
          id="reecosys-contact-us-section-1"
        >
          <div className="common-listing-banner relative">
            <img
              src={`${common_page_list.banner_web_full}&w=1920&h=750`}
              alt=""
            />
            <div className="common-list-overlay"></div>
            <div className="common-banner-title-abs">
              <div className="banner-title">
                <h1 className="white-color">{common_page_list.banner_title}</h1>
              </div>
            </div>
          </div>
          <div className="top-left-overlay-new"></div>
        </section>

        <section
          className="reecosys-section relative"
          id="reecosys-aboutus-section-2"
        >
          <div className="mini-container">
            <div className="inner-flex">
              {common_page_list.title && (
                <div className="section-information">
                  <div className="section-title">
                    <h2
                      className="wow fade_top"
                      data-wow-delay="0.3s"
                      data-wow-duration="0.6s"
                    >
                      {common_page_list.title}
                    </h2>
                  </div>
                </div>
              )}

              {common_page_list.primary_text_display && (
                <div className="section-content">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: common_page_list.primary_text_display,
                    }}
                  ></div>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
